export default __webpack_public_path__ + "static/media/how-to-view.7f7b65be.svg";